import * as React from "react";
import { Box, Button, Grid, Pagination, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AuthService from "../auth/AuthService";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Message from "../common/Message";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Link as NavLink } from "react-router-dom";
import { screenTypes, statuses } from "../common/constants";
import { LoaderSection } from "../common";
import { confirmationModal, appTheme } from "../utils";
const useStyles = makeStyles((theme) => ({
  row: {
    cursor: "pointer",
  },
  tblTopDiv: {},
  tblsearch: {
    float: "left",
  },
  addIcon: {
    float: "right",
  },
}));

const Auth = new AuthService();

export default function ScreenList() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [screens, setScreens] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [limit] = React.useState(50);
  const [loading, setLoading] = React.useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");

  React.useEffect(() => {
    setLoading(true);
    Auth.post(`/screen/screens`, {
      limit: limit,
      page: page,
      searchText: searchText,
    })
      .then((res) => {
        setLoading(false);
        if (res.ack) {
          setScreens(res.screens);
          setTotalPages(Math.ceil(res.total_count / limit));
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };
  const handleRowClick = (id) => {
    navigate("/screen/" + id);
  };

  const Search = () => {
    setLoading(true);
    Auth.post(`/screen/screens`, {
      limit: limit,
      page: 1,
      searchText: searchText,
    })
      .then((res) => {
        setLoading(false);
        if (res.ack) {
          setScreens(res.screens);
          setTotalPages(Math.ceil(res.total_count / limit));
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };
  const confirmToDelete = (id) => {
    const params = {
      method: "DELETE",
      body: JSON.stringify({
        id: id,
      }),
    };
    // setLoading(true);
    Auth.fetch(`/screen/screen`, params)
      .then((res) => {
        if (res.ack) {
          setType("info");
          setLoadMessage(res.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          // setLoading(false);
        } else {
          setType("error");
          setLoadMessage(res.message);
          // setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleDelete = (id) => {
    confirmationModal(() => {
      confirmToDelete(id);
    });
  };

  return (
    <div>
      <LoaderSection state={loading} />
      {/* <Button variant="contained" style={{marginBottom: "15px"}} onClick={()=>{window.location = "/import-screens"}}>Import Screens</Button> */}

      {/* ===================Old code Which are Grid Base ==============*/}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          marginTop: "5px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <TextField
            id="standard-adornment-password"
            type="text"
            label="Search"
            variant="outlined"
            name="searchText"
            value={searchText}
            size="small"
            onChange={handleSearch}
            // InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <IconButton aria-label="Search By Student Name" onClick={Search}>
            //         <SearchIcon />
            //       </IconButton>
            //     </InputAdornment>
            //   ),
            // }}
          />
          <Button
            // style={{ height: "55px" }}
            variant="contained"
            sx={{
              backgroundColor: appTheme.btnColor,
              "&:hover": {
                backgroundColor: appTheme.btnColor, // Change the color on hover
              },
            }}
            onClick={Search}
            endIcon={<SearchIcon />}
          >
            Search
          </Button>
        </Box>
        {Auth.getUserType() < 2 && (
          <NavLink to="/screen/new">
            {/* <Button
              style={{ height: "55px" }}
              variant="contained"
              sx={{
                backgroundColor: appTheme.btnColor,
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: appTheme.btnColor, // Change the color on hover
                },
              }}
              size="large"
            >
              Add Screen
            </Button> */}
            <AddCircleIcon
              fontSize="large"
              style={{
                color: appTheme.btnColor,
              }}
            />
          </NavLink>
        )}
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          marginTop: "15px",
        }}
      >
        <Table
          sx={{ width: "100%", border: "2px solid #b0aea9" }}
          aria-label="caption table"
        >
          <caption>List of Screens</caption>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold", width: "300px" }}>Title</TableCell>
              {/* <TableCell style={{ fontWeight: "bold" }}>Type</TableCell> */}
              <TableCell style={{ fontWeight: "bold" }}>Stores</TableCell>
              <TableCell style={{ fontWeight: "bold", width: "170px"  }}>
                Image Timeout (Seconds)
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
              {Auth.getUserType() < 2 && (
                <TableCell
                  style={{ fontWeight: "bold" }}
                  align="center"
                  width={50}
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {screens.map((row, index) => (
              <TableRow
                style={
                  index % 2
                    ? { background: "#D3D3D3" }
                    : { background: "white" }
                }
                key={row.id}
                className={classes.row}
              >
                <TableCell>{row?.title}</TableCell>
                {/* <TableCell>
                  {row.screen_type
                    ? screenTypes.filter((obj) => obj.id == row?.screen_type)[0]
                        ?.title
                    : ""}
                </TableCell> */}
                <TableCell>{row.stores1}</TableCell>
                <TableCell>{row.image_timeout}</TableCell>
                <TableCell>
                  {row.screen_status !== null
                    ? statuses.filter((obj) => obj.id == row.screen_status)[0]
                        ?.title
                    : ""}
                </TableCell>
                {Auth.getUserType() < 2 && (
                  <TableCell width={50} align="center">
                    <EditIcon
                      className={classes.actionBtn}
                      onClick={() => {
                        handleRowClick(row.id);
                      }}
                    />
                    <DeleteIcon
                      className={classes.actionBtn}
                      onClick={() => {
                        handleDelete(row.id);
                      }}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Message type={type} msg={loadMessage} />
      </TableContainer>
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
